module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"firmware_set_modal.title":"Firmware Set","firmware_set_modal.title.update":"แก้ไขข้อมูล Firmware Set","firmware_set_modal.ok":"เพิ่ม","firmware_set_modal.ok.update":"@:common.save","firmware_set.field.name.placeholder":"ชื่อเรียกสำหรับ Firmware ชุดนี้","firmware_set.field.remark.placeholder":"หมายเหตุ เช่น ใช้กับ Drone ทางการเกษตร"}}')
  delete Component.options._Ctor
}
